<template>
    <div>
        <v-autocomplete
            :label="label"
            :items="computedList"
            v-model="input"
            item-value="id"
            item-text="name"
            :loading="fetching"          
            :disabled="fetching || disabled"
            :auto-select-first="true"
            :filled="filled"
            @change="changed($event)"
            clearable
            hide-details
            :multiple="multiple"
            :dense="dense"
            style="min-width: 250px"
            />
    </div>
</template>
<script>
import SelectorService from '@services/front/SelectorService';

export default {
    props: {
        value: {
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        }, 
        label: { 
            type: String, 
            default: 'Seleccione un juego' 
        },
        params: {
            type: Object,
        },
        filled: {
            type: Boolean,
            default: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        autoselect: {
            type: Boolean,
            default: true,
        },
        filter: {
            default: function () {
                return juego => juego;
            }
        }
    },
    data: function () {
        return {
            fetching: false,
            list: [],
            input: this.multiple ? [] : null,
            debounceFetch: this.$lodash.debounce((reset = true) => {
                this.fetch(reset);
            }, 500)
        }
    },
    computed: {
        computedList: function () {
            return this.list.filter(this.filter);
        },
        defaultJuegoSlug: function () {
            return this.$store.getters['persist/default/defaultJuegoSlug'];
        },
    },
    mounted: function () {
        this.debounceFetch(false);
    },
    methods: {
        changed: function (value) {
            this.$emit('input', value);
            this.$emit('change', value);
            if (this.multiple) {
                this.$emit('update:juego', this.list.filter(juego => value.some(juego_id => juego_id == juego.id)));
            } else {
                this.$emit('update:juego', this.list.find(juego => juego.id == value));
            }
        },
        fetch: function (reset = true) {
            this.fetching = true;

            if (reset) this.input = this.multiple ? [] : null;
            else this.input = this.value;

            SelectorService
                .getJuego(this.params)
                .then(({ juegoList = [] }) => {
                    const list = this.list = juegoList;

                    if (list.length == 1) {
                        this.input = this.multiple ? [list[0].id] : list[0].id;
                    }

                    list.forEach((juego) => {
                        if (!this.autoselect) return;
                        if (juego.slug == this.defaultJuegoSlug) {
                            if (this.multiple && !this.input.length) {
                                this.input = [juego.id];
                            }
                            if (!this.multiple && !this.input) {
                                this.input = juego.id
                            }
                        }
                    });

                    if ((this.multiple && this.input.length) || (!this.multiple && this.input)) {
                        this.$emit('update:juego', 
                            this.multiple 
                                ? this.list.filter(juego => this.input.some(juego_id => juego_id == juego.id))
                                : this.list.find(juego => juego.id == this.input)
                        );
                    }
                })
                .finally(() => {
                    this.fetching = false;
                });
        },
    },
    watch: {
        value: function (value) {
            if (this.$lodash.isEqual(this.input, value)) return;
            this.input = this.multiple ? [value] : value;
        },
        input: {
            handler: function (value) {
                this.changed(value);
            },
            deep: true,
        },
        params: {
            handler: function (value, old) {
                if (this.$lodash.isEqual(value, old)) return;
                this.debounceFetch();
            },
            deep: true,
        }
    }
}
</script>